<template>
    <div class="card">
        <div>
            <div class="font-medium text-a-black-555555 text-12 leading-4.5">
                {{ items.acdno }}
            </div>
        </div>

        <div class="pt-1 flex items-end">
            <div class="flex-auto grid grid-cols-1 font-main font-light text-12 text-a-black-484848 leading-4.5">
                <div class="flex items-center pb-2px leading-4.5">
                    <div class="flex-none w-12">
                        สถานะ
                    </div>
                    <div class="flex-auto">
                        {{ items.claim_status }}
                    </div>
                </div>
                <div class="flex items-center leading-4.5">
                    <div class="flex-none w-12">
                        รับแจ้ง
                    </div>
                    <div class="flex-auto">
                        {{ items.occurrence_datetime }}
                    </div>
                </div>
            </div>
            <div class="flex-none">
                <button type="button" @click="clickDetail()"
                    class="outline-none appearance-none bg-a-orange-fe5000 text-white text-11 font-main font-light rounded-full h-7.5 px-4">
                    <div class="leading-15px">รายละเอียด</div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useTracking } from "@/feature/TrackingFeature"

export default defineComponent({
    props: {
        items: {
            type: Object,
        }
    },
    setup: function (props) {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        const clickDetail = () => {
            tracking.event("claim_history_page", "click_detail", "", "");
            let url = props.items.tracking_rul
            window.location.href = url
        }
        return {
            clickDetail,
        }
    },
})
</script>

<style lang="scss" scoped>
.card {
    border-radius: 13px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
    @apply bg-white flex flex-col min-w-0 p-4 pr-2 font-main;

    .text-desc {
        @apply font-medium text-12 text-a-black-484848;
    }

    .text-desc-light {
        @apply font-light text-12 text-a-black-484848;
    }
}
</style>
